export enum ZipValidationErrors {
  INVALID_ZIP_CODE = "INVALID_ZIP_CODE",
  NO_LAB = "NO_LAB",
  EMPTY = "EMPTY",
  FETCH_FAILED = "FETCH_FAILED",
}
